import { ChevronDown } from "lucide-react";
import { formatNationalPhone, getPhoneCountry, phoneCountries, splitPhoneNumber } from "../lib/phone";

type PhoneInputProps = {
  country: string;
  value: string;
  onChange: (value: string) => void;
  onCountryChange: (country: string, callingCode: string) => void;
  disabled?: boolean;
  required?: boolean;
  label?: string;
  name?: string;
};

export function PhoneInput({
  country,
  value,
  onChange,
  onCountryChange,
  disabled = false,
  required = false,
  label = "Телефон гостя",
  name = "phone",
}: PhoneInputProps) {
  const selected = getPhoneCountry(country);
  return <label className="field field--wide phone-input-field">
    <span>{label}</span>
    <div className="phone-input" data-disabled={disabled || undefined}>
      <div className="phone-input__country">
        <span className="phone-input__flag" aria-hidden="true">{selected.flag}</span>
        <span className="phone-input__country-name">{selected.name}</span>
        <strong>{selected.callingCode}</strong>
        <ChevronDown size={13} aria-hidden="true" />
        <select
          aria-label="Страна и телефонный код"
          value={selected.iso}
          disabled={disabled}
          onChange={(event) => {
            const next = getPhoneCountry(event.target.value);
            onCountryChange(next.iso, next.callingCode);
          }}
        >
          {phoneCountries.map((item) => <option value={item.iso} key={item.iso}>{item.flag} {item.name} · {item.callingCode}</option>)}
        </select>
      </div>
      <input
        required={required}
        disabled={disabled}
        name={name}
        type="tel"
        inputMode="tel"
        autoComplete="tel-national"
        aria-label="Номер телефона"
        value={formatNationalPhone(value, selected.iso)}
        placeholder={selected.example}
        onChange={(event) => {
          const entered = event.target.value;
          const parsed = splitPhoneNumber(entered, selected.iso, selected.callingCode);
          if ((entered.trim().startsWith("+") || entered.trim().startsWith("00")) && parsed.country.iso !== selected.iso) {
            onCountryChange(parsed.country.iso, parsed.country.callingCode);
          }
          onChange(parsed.nationalNumber);
        }}
      />
    </div>
    <small className="phone-input__hint">Можно вставить номер целиком с «+» — страна определится автоматически</small>
  </label>;
}
